import { FaCheck, FaRegCheckCircle, FaRegTimesCircle, FaTimes } from "react-icons/fa";
import TooltipButton from "views/Documents/components/TooltipButton";
import { MdEdit } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { Button, Col, Row } from "antd";

interface UseCurrencyTableColumnsProps {
  handleOnSave: (record: Record<string, any>) => void;
  handleOnCancel: () => void;
  isEditing: (record: Record<string, any>) => boolean;
  handleOnEdit: (record: Record<string, any>) => void;
}

export default function useCurrencyTableColumns({
  handleOnSave,
  handleOnCancel,
  isEditing,
  handleOnEdit,
}: UseCurrencyTableColumnsProps) {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("Code"),
      dataIndex: "code",
      width: "10%",
    },
    {
      title: t("Decimal cases"),
      dataIndex: "decimalPlaces",
      width: "15%",
      inputType: "text",
      editable: true,
    },
    {
      title: t("Main currency"),
      align: "center",
      editable: true,
      dataIndex: "isMainCurrency",
      inputType: "boolean",
      width: "15%",
      render: (_text: unknown, record: Record<string, any>) =>
        record.isMainCurrency ? (
          <FaRegCheckCircle color="green" size={16} />
        ) : (
          <FaRegTimesCircle color="red" size={16} />
        ),
    },
    {
      title: t("Active"),
      align: "center",
      editable: true,
      dataIndex: "isActive",
      inputType: "boolean",
      width: "15%",
      render: (_text: unknown, record: Record<string, any>) =>
        record.isActive ? (
          <FaRegCheckCircle color="green" size={16} />
        ) : (
          <FaRegTimesCircle color="red" size={16} />
        ),
    },
    {
      key: "Actions",
      title: t("Actions"),
      width: "15%",
      align: "center",
      render: (_: unknown, record: Record<string, any>) => {
        const editable = isEditing(record);
        return editable ? (
          <Row gutter={8} className="centered">
            <Col>
              <Button
                type="primary"
                size="small"
                className="saveCustomButton"
                onClick={handleOnSave}
              >
                <FaCheck />
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                size="small"
                className="cancelCustomButton"
                onClick={handleOnCancel}
              >
                <FaTimes />
              </Button>
            </Col>
          </Row>
        ) : (
          <Row gutter={8} className="centered">
            <TooltipButton placement="top" handleOnClick={() => handleOnEdit(record)} icon={<MdEdit />} />
          </Row>
        );
      },
    },
  ];

  const mergedColumns = columns?.map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: Record<string, any>) => ({
        record,
        inputType: col.inputType,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return mergedColumns;
}
